import { useState, useCallback } from 'react';

export type WeightUnit = 'kg' | 'gram';

export interface UseWeightUnitReturn {
  unit: WeightUnit;
  setUnit: (unit: WeightUnit) => void;
  toggleUnit: (unit?: WeightUnit) => void;
  convertWeight: (valueKg: number) => number;
  toKg: (value: number) => number;
}

export const useWeightUnit = (defaultUnit: WeightUnit | string = 'kg'): UseWeightUnitReturn => {
  const initialUnit: WeightUnit = defaultUnit === 'gram' ? 'gram' : 'kg';
  const [unit, setUnit] = useState<WeightUnit>(initialUnit);

  const toggleUnit = useCallback((nextUnit?: WeightUnit) => {
    if (nextUnit) {
      setUnit(nextUnit);
      return;
    }
    setUnit((prev) => (prev === 'kg' ? 'gram' : 'kg'));
  }, []);

  const convertWeight = useCallback((valueKg: number): number => {
    if (unit === 'gram') {
      return valueKg * 1000;
    }
    return valueKg;
  }, [unit]);

  const toKg = useCallback((value: number): number => {
    if (unit === 'gram') {
      return value / 1000;
    }
    return value;
  }, [unit]);

  return {
    unit,
    setUnit,
    toggleUnit,
    convertWeight,
    toKg,
  };
};
